import { createGlobalStyle } from "styled-components";

export const CustomStyleTable = createGlobalStyle`
.auth-detail-table {
  width: 100%;
  .ant-table-container {
    border: unset !important;
  }
  table {
    border: unset !important;
    .ant-table-thead .ant-table-cell {
      background: #2c2c31;
      &:last-child {
        background: #262729 !important;
        border-right: unset !important;
      }
    }
    .ant-table-cell {
      padding: 0 16px !important;
      border-right: 1px solid #343538 !important;
      // background: #2c2c31 !important;
      label {
        height: 22px;
      }
    }
  }
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    border-bottom: 1px solid #343538 !important;
  }
  &.edit {
    .ant-table-cell {
      background: #2c2c31 !important;
      border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
    }
    .ant-table-tbody > tr > td.ant-table-cell-row-hover {
      border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    }
  }
  .renderbus-ui--checkbox {
    margin-left: unset;
    min-width: unset;
  }
  .ant-table-row.ant-table-row-level-0 {
    .ant-table-cell:last-child {
      height: min-content !important;
      padding-bottom: unset;
      padding-top: 12px !important;
      background: #262729 !important;
      border-right: unset !important;
      label {
        margin-bottom: 15px;
      }
      label span {
        font-size: 12px !important;
      }
    }
  }
  .ant-table-thead th {
    text-align: center !important;
  }
}
`;
